<template>
    <div id="main-wrapper">
       <AdminNavbar/>

        <div class="page-title">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <h2 class="ipt-title">{{t('Welcome!')}}</h2>
                    </div>
                </div>
            </div>
        </div>

        <section class="bg-light">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-3 col-md-12">
                        <AdminSidebar :open="show" @update:open="show = $event" :user="visitor" @update:user="visitor = $event"/>
                    </div>
                </div>
            </div>
        </section>

        <FooterTop :bg="'theme-bg'"/>

        <FooterDark/>

        <ScrollToTop/>

    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import AdminSidebar from '@/components/admin-sidebar.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import AdminNavbar from '@/components/navbar/admin-navbar.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import { useI18n } from "vue-i18n"
import axios from 'axios'
import { useToast } from 'vue-toastification'
import { useRouter } from 'vue-router';
const { t } = useI18n()
const show = ref(false);

const visitor = ref(null)
const toast = useToast()
const route = useRouter();
onMounted(async () => {
const token = localStorage.getItem('auth_token')
if (!token) {
    toast.error(t('You are not logged in.'))
    route.push(`/404`).then(() => {
        location.reload();
    });
    return
}

try {
    const response = await axios.get('/visitor', {
    headers: {
        Authorization: `Bearer ${token}`
    }
    })
    visitor.value = response.data.user
    console.log('Visitor details:', visitor.value)
} catch (error) {
    console.error('Error fetching visitor details:', error)
    toast.error(t('Failed to load profile information.'))
}
})
</script>
